import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import "./styles/DeleteStickerPopup.css";

const DeleteStickerPopup = ({ onConfirm, open, close }) => {  
  return (
    <GenericPopup
      open={open}
      className="delete-sticker-popup__container"
      opacity
    >
      <div className="delete-sticker-popup__content">
        <div className="delete-sticker-popup__header">
          <Text className="delete-sticker-popup__header-text">
            Delete Sticker
          </Text>
          <XIcon className="delete-sticker-popup__close-button" onClick={close} />
        </div>

        <Text className="delete-sticker-popup__message">
          Are you sure you want to delete this sticker?
        </Text>
      </div>
      <div className="delete-sticker-popup__buttons">
        <ContinueButton 
          type="button"
          onClick={(event) => {
            onConfirm(event);
            close();
          }} 
          className="font-size-medium"
        >
          Yes, delete
        </ContinueButton>
      </div>
    </GenericPopup>
  );
};

export default DeleteStickerPopup;
